module.exports = __webpack_public_path__ + "assets/stores-54ab84.svg";